import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@components/ui/sidebar";
import { SettingsIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { useLingui } from "@lingui/react/macro";
import { UserDropdown } from "./UserDropdown";

export function FooterNav({
  orgUuid,
  pathname,
}: {
  orgUuid: string;
  pathname: string;
}) {
  const { t } = useLingui();

  const FOOTER_LINKS = [
    {
      label: t`Inställningar`,
      to: ROUTES.SETTINGS_MY_ACCOUNT_ORGID.replace(":orgUuid", orgUuid),
      icon: SettingsIcon,
    },
  ];

  return (
    <SidebarMenu className="gap-4">
      {FOOTER_LINKS.map((link) => (
        <SidebarMenuItem key={link.to}>
          <SidebarMenuButton asChild isActive={pathname === link.to}>
            <Link to={link.to}>
              <link.icon />
              {link.label}
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}

      <UserDropdown orgUuid={orgUuid} />
    </SidebarMenu>
  );
}
